import { styled } from 'styled-components';

export const StyledImg = styled.img`
    display: block;
    height: auto;
    width: 100%;
`;
